





















































import { CertificadoInterService } from '@/services/certificado-inter.service';
import { ToastService } from '@/services/toast.service';
import { date } from '@/shared/filters';
import GlobalMixin from '@/shared/mixins/globalMixin';
import { required } from '@/shared/validators';
import Component, { mixins } from 'vue-class-component';

@Component({
    filters: {
        date,
    },
})
export default class ConfigurarCertificadoInter extends mixins(GlobalMixin) {
    validade: Date | null = null;
    arquivoCrt: File | null = null;
    arquivoKey: File | null = null;

    configuracaoAtual: any = null;
    jaEntendi = false;

    rules = {
        validade: [
            required(),
        ],
        arquivoCrt: [
            required(),

        ],
        arquivoKey: [
            required(),

        ]
    };

    mounted() {
        this.fetchConfiguracao();
    }

    async fetchConfiguracao() {
        this.configuracaoAtual = await CertificadoInterService.obterConfiguracao();
    }

    configurar() {
        console.log(this);
        if ((this.$refs.form as any).validate()) {
            this.startLoader();

            CertificadoInterService.configurar({
                validade: this.validade!,
                arquivoCrt: this.arquivoCrt!,
                arquivoKey: this.arquivoKey!
            })
                .then(() => {
                    this.validade = null;
                    this.arquivoCrt = null;
                    this.arquivoKey = null;

                    (this.$refs.form as any).reset();

                    ToastService.open({
                        position: "top-end",
                        message: "Configuração salva com sucesso!",
                        duration: 3000,
                        type: "success",
                    });

                    if (!this.jaEntendi) {
                        this.fetchConfiguracao();
                    }
                })
                .finally(() => {
                    this.stopLoader();
                });
        }
    }
}
